import React, { useEffect } from 'react';
import '../../../assets/css/antd.css';
import {Button, Form, Input, Modal, Radio, Steps} from 'antd';
import {inject, observer} from 'mobx-react';
import styled from 'styled-components';
import {useHistory} from 'react-router-dom';
import checked from "../style/img/checked.svg"
import TextArea from 'antd/lib/input/TextArea';

const { Step } = Steps;

const DiagnosisTemplate = inject("DiagnosisStore")(observer((props) => {
    const history = useHistory();

    useEffect(() => {
        props.DiagnosisStore.getQuestionList(props.DiagnosisStore.category)
            .then(data => {
                props.DiagnosisStore.setQuestionList(data);
            });
            window.scrollTo(0, 0);
    }, [props.DiagnosisStore.category]);
        
    const questionLists = props.DiagnosisStore.questionList;

    const onFinish1 = values => {
        let diagnosisQuestion = props.DiagnosisStore.answerList.diagnosis_question;

        props.DiagnosisStore.questionList.map((list) => {
            for (let num in values) {
                let description = Object.assign({}, Object.values(values[num]))[0];
                const name = Object.keys(values[num]).join();

                if(description && list.id === parseInt(num)) {
                    let question = {
                        order: list.order,
                        question_id: list.id,
                        name: name,
                        diagnosis_answer: []
                    };
                    if(list.type ===1 ) {
                        question.diagnosis_answer.push({
                            description: description
                        });
                    } else if (list.type === 2) {
                        list.answer.filter((answer) => description === answer.description &&
                        (answer.id === 43 ?
                            question.diagnosis_answer.push({
                                answer_id: answer.id,
                                description: props.DiagnosisStore.etcDescriptionList[0].description
                            }) :
                            question.diagnosis_answer.push({
                                answer_id: answer.id,
                            })
                        ))
                    } else if (list.type === 3) {
                        question.diagnosis_answer.push({
                            description: Object.assign({}, Object.values(values[num]))[0]
                        });
                    }

                    diagnosisQuestion.push(question);
                }
            }
        });

        const processData = diagnosisQuestion = diagnosisQuestion.reduceRight((acc, cur) => {
            if(!acc.filter(i => i.question_id === cur.question_id).length) acc.push(cur);
            return acc;
        }, []).reverse();

        props.DiagnosisStore.setDiagnosisQuestion(processData);

        props.DiagnosisStore.setCategory("diagnosis2");
    };

    const onFinish2 = values => {
        let diagnosisQuestion = props.DiagnosisStore.answerList.diagnosis_question;

        props.DiagnosisStore.questionList.map((list) => {
            for (let num in values) {
                let description = Object.assign({}, Object.values(values[num]))[0];
                const name = Object.keys(values[num]).join();

                if(description && list.id === parseInt(num)) {
                    let question = {
                        order: list.order,
                        question_id: list.id,
                        name: name,
                        diagnosis_answer: []
                    };
                    if(list.type ===1 ) {
                        question.diagnosis_answer.push({
                            description: description
                        });
                    } else if (list.type === 2) {
                        list.answer.filter((answer) => description === answer.description &&
                            (answer.id === 69 ?
                                question.diagnosis_answer.push({
                                    answer_id: answer.id,
                                    description: props.DiagnosisStore.etcDescriptionList[1].description
                                }) :
                                question.diagnosis_answer.push({
                                    answer_id: answer.id,
                                })
                            )
                        )
                    } else if (list.type === 3) {
                        question.diagnosis_answer.push({
                            description: Object.assign({}, Object.values(values[num]))[0]
                        });
                    }

                    diagnosisQuestion.push(question);
                }
            }
        });

        const processData = diagnosisQuestion = diagnosisQuestion.reduceRight((acc, cur) => {
            if(!acc.filter(i => i.question_id === cur.question_id).length) acc.push(cur);
            return acc;
        }, []).reverse();

        props.DiagnosisStore.setDiagnosisQuestion(processData);

        props.DiagnosisStore.createAnswer(props.DiagnosisStore.answerList)
            .then(() => {
                history.push("/end");
            });
    };

    const Private = () => {
        Modal.info({
          title: '개인정보 수집 동의에 따른 취급 방침',
          okText: '확인',
          content: (
            <div className="contents">
              <p>1. 개인 정보 수집 이용 목적 수집하는 주체 및 이용 목적</p>

              <p>가. 포데이트 브랜드를 책임지는 회사 럽디(주)</p>

              <p>나. 럽디(주)는 수집한 개인정보를 다음의 목적을 위해 활용합니다. </p>

              <p>- 사전 분석을 통한 양질의 상담 서비스</p>

              <p>- 수강 신청, 상담 문의에 대한 안내 및 케어</p>

              <p>- 상담 후 후속 처리를 위한 서비스의 안내 및 조언</p>

              <p>다. 각색 이용. 보내주신 사연의 개인을 특정할 정보를 제외한 럽디(주)가 제공한 솔루션의 권한은 럽디(주)에 귀속되며, 이를 저작물 등의 소재로 사용할 수 있습니다. 단, 제공해주신 사연의 경우 사연제공자 본인 동의를 구하지 않은 상태에서는 절대 인물특정을 할 수 없도록 반드시 각색하고 익명으로 사용합니다.</p>

              <p>2. 개인 정보 항목 및 수집 방법</p>

              <p>가. 개인 정보 항목 : 성함, 연락처, 인물을 특정할 수 있는 위치 정보 및 교제 날짜 정보, 이별 날짜 정보</p>

              <p>나. 럽디(주)는 다음과 같은 방법으로 개인 정보를 수집합니다.</p>

              <p>- 구글 설문을 통한 진단 접수, 상담을 통한 접수</p>

              <p>3. 수집한 개인 정보의 보유 및 이용기간</p>

              <p>- 개인 정보 수집 및 이용 목적이 달성된 후 1년 뒤, 통계처리를 위해 각색된 데이터 외의 해당 정보를 파기합니다.</p>

              <p>4. 개인 정보 수집에 동의하지 않으실 경우, 진단지는 열람되지 않으며, 상담 예약 전까지는 상담사가 해당 정보를 열람하는 것이 불가능하여, 진단을 드릴 수 없게 됩니다. 참고해주세요.</p>

              <p>개인정보보호책임자 : 이장원</p>
              <p>메일 : answer@luvd.co.kr</p>
              <p>전화 : 02-588-0717</p>
            </div>
          ),
          onOk() {},
        });
    };

    const Sensitive = () => {
        Modal.info({
          title: '민감정보 수집 동의에 따른 개인 정보 취급 방침',
          okText: '확인',
          content: (
            <div className="contents">
                <p>1. 개인 정보 수집 이용 목적 수집하는 주체 및 이용 목적</p>

                <p>가. 연애의 자격 브랜드를 책임지는 회사 럽디(주)</p>

                <p>나. 럽디(주)는 수집한 개인정보를 다음의 목적을 위해 활용합니다. </p>

                <p>- 사전 분석을 통한 양질의 상담 서비스</p>

                <p>- 상담 문의에 대한 안내 및 케어</p>

                <p>- 상담 후 후속 처리를 위한 서비스의 안내 및 조언</p>

                <p>다. 각색 이용. 보내주신 사연의 개인을 특정할 정보를 제외한 럽디(주)가 제공한 솔루션의 권한은 럽디(주)에 귀속되며, 이를 저작물 등의 소재로 사용할 수 있습니다. 단, 제공해주신 사연의 경우 사연제공자 본인 동의를 구하지 않은 상태에서는 절대 인물특정을 할 수 없도록 반드시 각색하고 익명으로 사용합니다.</p>

                <p>2. 민감 정보 항목</p>

                <p>- 연애, 이별에 따른 건강, 성생활 등에 대한 정보</p>

                <p>3. 수집한 민감 정보의 보유 및 이용기간</p>

                <p>- 개인 정보 수집 및 이용 목적이 달성된 후 1년 뒤, 통계처리를 위해 각색된 데이터 외의 해당 정보를 파기합니다.</p>

                <p>4. 민감 정보 수집 동의 거부의 권리 </p>

                <p>- 고객은 민감 정보의 수집, 이용 등과 관련하여 위 사항에 대하여 원하지 않는 경우 동의를 거부할 수 있습니다. 해당 정보의제공을 원하지 않을 경우 수집하지 않으며, 미동의로 인해 상담이 제한될 수 있습니다.</p>

                <p>개인정보보호책임자 : 이장원</p>
                <p>메일 : answer@luvd.co.kr</p>
                <p>전화 : 02-588-0717</p>
            </div>
          ),
          onOk() {},
        });
    };

    return (
        <>
            <Header>
                <div className="name">연애 심층 진단지</div>
                <div className="sub-name">
                    <figure>
                        <img src={require("../style/img/magnifying-glass.svg")} alt="돋보기"/>
                    </figure>
                    <div className="text_box">
                        <p>'내 이상형'과 한달 안에</p>
                        <p>연애할 수 있을까?</p>
                    </div>
                </div>
            </Header>
            <ProgressBox>
                <Steps progressDot current={props.DiagnosisStore.category==="diagnosis1" ? 1:2}>
                    <Step/>
                    <Step/>
                    <Step/>
                </Steps>
            </ProgressBox>
            {
                props.DiagnosisStore.category ==="diagnosis1" ?
                    <Wrap>
                        <div className="guide_box">
                            <p className="title">참 괜찮은 당신</p>
                            <p className="sub-title">맞춤 분석을 하기위해 필요합니다.</p>
                            <div className="img_box">
                                <p>좋은 연애를 고민하는</p>
                                <p>좋은 사람들만 모이는곳</p>
                                <figure>
                                    <img src={require("../style/img/fordate.svg")} alt="포데이트"/>
                                </figure>
                                <img src={require("../style/img/fordate-bg.svg")} className="fordate-bg" alt="포데이트 배경"/>
                            </div>
                            <div className="required">
                                <span className="special"></span>
                                <span className="text">필수항목</span>
                            </div>
                        </div>

                        <Form
                            name="validate_1"
                            onFinish={onFinish1}
                        >
                            {
                                questionLists && questionLists.map((list) => {
                                    return (
                                        <Form.Item
                                            key={list.id}
                                            label={list.description}
                                            name={[`${list.id}`, `${list.name}`]}
                                            rules={[{ required: list.required, message: '필수 질문입니다' }]}
                                        >
                                            {
                                                list.type===1 ? <Input placeholder="답변"/> :
                                                <Radio.Group className={list.answer && list.answer.length === 2 ? "horizontal": "vertical"}>
                                                    {
                                                        list.answer.map((answer) => {
                                                            return (
                                                                <Radio
                                                                    key={answer.id}
                                                                    value={answer.description}
                                                                >
                                                                       <span>{answer.description}</span>
                                                                       {answer.type === 2 ? 
                                                                            <TextArea
                                                                                autoSize={{ minRows: 1, maxRows: 6 }}
                                                                                onChange={(e)=> props.DiagnosisStore.setEtcDescription1(e.target.value)}
                                                                                value={props.DiagnosisStore.etcDescriptionList[0].description}
                                                                                className="textarea"
                                                                                allowClear
                                                                            /> : null}
                                                                </Radio>
                                                            )
                                                        })
                                                    }
                                                </Radio.Group>
                                            }
                                        </Form.Item>
                                    )
                                })
                            }
                            <div className="bt_box">
                                <Button className="prev" onClick={()=> history.push("/")}>
                                    <img src={require("../style/img/prev.svg")} alt="뒤로"/>
                                    <span>뒤로</span>
                                </Button>
                                <Button className="next" htmlType="submit">
                                    <span>다음</span>
                                    <img src={require("../style/img/next.svg")} alt="다음"/>
                                </Button>
                            </div>
                        </Form>
                    </Wrap> :
                    <Wrap>
                        <div className="guide_box">
                            <p className="title">연애스토리</p>
                            <p className="sub-title">연애에 대한 생각, 현재 상황을 자세히 적어주실수록 좋은 사람과 한달안에 연애할 가능성에 대해  더 정확히 진단 가능합니다.</p>
                            <div className="required">
                                <span className="special"></span>
                                <span className="text">필수항목</span>
                            </div>
                        </div>
                        <Form
                            name="validate_2"
                            onFinish={onFinish2}
                        >
                            {
                                questionLists && questionLists.map((list) => {
                                    return (
                                        <Form.Item
                                            key={list.id}
                                            label={list.description}
                                            name={[`${list.id}`, `${list.name}`]}
                                            rules={[{ required: list.required, message: '필수 질문입니다' }]}
                                        >
                                            {
                                                list.type===1 ? <Input placeholder="답변"/> :
                                                    list.type===2 ?
                                                        <Radio.Group className={list.answer && list.answer.length === 2 ? "horizontal": "vertical"}>
                                                            {
                                                                list.answer.map((answer) => {
                                                                    return (
                                                                        <Radio
                                                                            key={answer.id}
                                                                            value={answer.description}
                                                                        >
                                                                            <span>{answer.description}</span>
                                                                            {answer.type === 2 ? 
                                                                                <TextArea
                                                                                    autoSize={{ minRows: 1, maxRows: 6 }}
                                                                                    onChange={(e)=> props.DiagnosisStore.setEtcDescription2(e.target.value)}
                                                                                    value={props.DiagnosisStore.etcDescriptionList[1].description}
                                                                                    className="textarea"
                                                                                    allowClear
                                                                                /> : null}
                                                                        </Radio>
                                                                    )
                                                                })
                                                            }
                                                        </Radio.Group> :
                                                        list.type===3 ?
                                                            <Radio.Group className="align add-text">
                                                                <Radio value={1}></Radio>
                                                                <Radio value={2}></Radio>
                                                                <Radio value={3}></Radio>
                                                                <Radio value={4}></Radio>
                                                                <Radio value={5}></Radio>
                                                                <Radio value={6}></Radio>
                                                                <Radio value={7}></Radio>
                                                                <Radio value={8}></Radio>
                                                                <Radio value={9}></Radio>
                                                                <Radio value={10}></Radio>
                                                            </Radio.Group> : null
                                            }
                                        </Form.Item>
                                    )
                                } )
                            }
                            <div className="agree_box">
                                <div className="container">
                                    <Form.Item name="privateAgree" rules={[{ required: true, message: '개인정보 수집에 동의해주세요' }]}>
                                        <Radio.Group className="private">
                                            <Radio value={true} onChange={()=> props.DiagnosisStore.setPrivateAgree(true)}>개인정보 수집 동의</Radio>
                                            <Button onClick={Private}>보기</Button>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>
                                <div className="container">
                                    <Form.Item name="privacyAgree" rules={[{ required: true, message: '민감정보 수집에 동의해주세요' }]}>
                                        <Radio.Group className="sensitive">
                                            <Radio value={true} onChange={()=> props.DiagnosisStore.setPrivacyAgree(true)}>민감정보 수집 동의</Radio>
                                            <Button onClick={Sensitive}>보기</Button>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>
                                <div className="contents">
                                    <div className="cont">
                                        <p>동의하지 않으실 경우, 코칭 예약 전까지 </p>
                                        <p>해당정보를 열람하는 것이 불가능하여,</p>
                                        <p>진단을 드릴 수 없게 됩니다.</p>
                                    </div>

                                    <div className="cont">
                                        <p>코칭 예약을 바로 원하시면 카카오톡에서</p>
                                        <p>@포데이트 친구추가를 하시고 이야기해주시면</p>
                                        <p>바로 진행해드리겠습니다.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="fordate">
                                <div className="cont">
                                    <img src={require("../style/img/exclamation-mark.svg")} alt="느낌표"/>
                                    <div>
                                        <p>제출 완료 후에 카카오톡 @포데이트로</p>
                                        <p>성함+휴대폰 뒷번호를 보내주세요.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="bt_box">
                                <Button className="prev" onClick={() => props.DiagnosisStore.setCategory("diagnosis1")}>
                                    <img src={require("../style/img/prev.svg")} alt="뒤로"/>
                                    <span>뒤로</span>
                                </Button>
                                <Button className="next" htmlType="submit">
                                    <span>다음</span>
                                    <img src={require("../style/img/next.svg")} alt="다음"/>
                                </Button>
                            </div>
                        </Form>
                    </Wrap>
            }
        </>
    );
}));

const Header = styled.header`
    max-width: 1200px;
    height: 118px;
    margin: 0 auto;
    background-color: #f3f3f3;
    overflow: hidden;
    box-sizing:border-box;

    .name {
        text-align: center;
        font-size: 17px;
        margin-top: 17px;
        color: #656565;
        font-family: 'NanumSquare', sans-serif;
    }

    .sub-name {
        margin: 13px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;

        figure {
            margin: 0 8px 0 0;
        }

        .text_box {
            p {
                font-family: 'NanumSquare', sans-serif;
                margin: 0;
                text-align: left;
                font-weight: 600;
                font-size: 22px;
                color: #3d3d3d;
                line-height: 1.2;
            }
        }
    }

    @media screen and (max-width:768px) {
        max-width: 100vw;
    }
`;

const ProgressBox = styled.div`
    margin: 28.5px auto 0;
    display: flex;
    justify-content: center;

    .ant-steps {
        margin: 0 auto;
        width: auto;
    }

    .ant-steps-item {
        flex:0;
    }

    .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
        background-color: #f0526d;
    }

    .ant-steps-dot .ant-steps-item-process .ant-steps-item-icon, .ant-steps-dot.ant-steps-small .ant-steps-item-process .ant-steps-item-icon {
        width: 21px;
        height: 21px;
        margin-top: -6px;
        margin-left: 44px;
    }

    .ant-steps-dot .ant-steps-item-icon,
    .ant-steps-dot.ant-steps-small .ant-steps-item-icon {
        margin-left: 47px;
    }

    .ant-steps-dot .ant-steps-item-tail, .ant-steps-dot.ant-steps-small .ant-steps-item-tail {
        margin: 0 0 0 50px;
    }

    .ant-steps-dot .ant-steps-item-tail::after, .ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {
        height: 1px;
    }

    .ant-steps-dot .ant-steps-item-content, .ant-steps-dot.ant-steps-small .ant-steps-item-content {
        width: 100px;
    }

    .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot,
     .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot,
     .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
        background: #f0526d;
    }
`;

const Wrap = styled.div`
    max-width: 940px;
    margin: 36.5px auto 0;
    box-sizing:border-box;

    .guide_box {
        .title {
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            object-fit: contain;
            background-image: linear-gradient(to right, #e3457a 0%, #f46666 100%);
            font-size: 28px;
            font-weight: 800;
        }

        .sub-title {
            margin-top: 11px;
            font-size: 16px;
            font-weight: 100;
            color: #969696;
        }

        .img_box {
            position: relative;
            background-image: linear-gradient(to left, #fd6060, #e3457b);
            text-align: center;
            height: 127px;
            border-radius: 5px;
            overflow: hidden;
            margin-top: 16px;
            
            p {
                font-size:20px;
                margin: 0;
                color: #fff;
                &:first-child {
                    margin-top: 18px;
                    font-weight: 100;
                }
            }

            figure {
                margin-top:10px;
            }

            .fordate-bg {
                position: absolute;
                top:50%;
                left:50%;
                transform:translate(-50%, -50%);
            }
        }

        .required {
            margin-top: 12px;
            span {
                &.special {
                    display:inline-block;
                    border-radius: 50%;
                    width: 6px;
                    height: 6px;
                    background-color: #f0526d;
                    margin-left: 5px;
                    margin-bottom: 4px;
                }
                &.text {
                    font-size: 14px;
                    color: #808080;
                    margin-left: 5px;
                }
            }
        }
    }

    .ant-form {
        margin: 31px auto 0;

        .ant-form-item {
            display: block;
            & + .ant-form-item {
                margin-top: 47px;
            }
        }

        .ant-form-item-label {
            > label {
                font-size: 16px;
                color: #3e3e3e;
                font-weight: 600;
                height: auto;
                word-break: keep-all;

                &.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
                    content: "";
                    display:inline-block;
                    border-radius: 50%;
                    width: 6px;
                    height: 6px;
                    background-color: #f0526d;
                    margin-left: 3px;
                    margin-bottom: 12px;
                }
            }
        }

        .ant-form-item-control {
            margin-top: 23px;
        }

        div[role="alert"] {
            position: relative;
            padding-left: 12.5px;

            &::before {
                position: absolute;
                content:"";
                width: 6px;
                height:6px;
                background-color: #f0526d;
                left:0px;
                top:50%;
                transform: translateY(-50%);
                border-radius: 50%;
            }
        }

        .ant-input {
            padding:0;
            border: none;
            font-size:18px;
            font-family: 'NanumSquareRound', sans-serif;
            border-bottom: 1px solid #c5c5c5;
        }

        .ant-row.ant-form-item.ant-form-item-has-success .ant-input{
            border-bottom: 1px solid #323232;
        }

        .ant-row.ant-form-item.ant-form-item-with-help.ant-form-item-has-error .ant-input{
            border-bottom: 1px solid #f0526d;
        }

        .ant-radio-group {
            &.horizontal {
                display: flex;
                > .ant-radio-wrapper {
                    & + .ant-radio-wrapper {
                        margin-left: 38px;
                    } 
                }
            }
            &.align {
                display: flex;
                justify-content: space-between;
            }
            &.vertical {
                width: 100%;
                > .ant-radio-wrapper {
                    display: flex;
                    & + .ant-radio-wrapper {
                        margin-top: 15px;
                    }
                    >span {
                        word-break: keep-all;
                    }

                    > span:nth-child(2){
                        padding-right:0;
                        display: block;
                        width: 100%;

                        input {
                            width: calc(100% - 29px);
                        }
                    }

                    .textarea {
                        width: calc(100% - 34px);
                    }

                    &:last-child {
                        .ant-radio {
                            align-self: flex-start;
                        }
                    }
                }
            }
            
            &.add-text {
                box-sizing: border-box;
                position: relative;

                &::before {
                    position: absolute;
                    content:"전혀 그렇지 않다";
                    bottom:-100%;
                    left:0;
                    width: auto;
                    height: auto;
                    font-size: 14px;
                    font-family: 'NanumSquareRound', sans-serif;
                    color: #808080;
                }

                &::after {
                    position: absolute;
                    content:"매우 그렇다";
                    bottom:-100%;
                    right:0;
                    width: auto;
                    height: auto;
                    z-index:99;
                    font-size: 14px;
                    text-align:right;
                    font-family: 'NanumSquareRound', sans-serif;
                    color: #808080;
                }
            }
        }

        .ant-radio-wrapper{
            display: flex;
            align-items: center;
            margin-right: 0;
            span {
                font-size: 16px;
                color: #808080;
            }
        }
    

        .ant-radio {
            &.ant-radio-checked {
                .ant-radio-inner {
                    border-style: none;
                    background-color: #f0526d;
                    position: relative;
                    z-index:5;
                    &::after {
                        position: absolute;
                        content:"";
                        top:50%;
                        left:50%;
                        width: 100%;
                        height: 100%;
                        transform: translate(-50%, -50%);
                        background-image: url(${checked});
                        background-repeat: no-repeat;
                        background-position: center;
                        z-index: 10;
                    }
                }
            }
        }

        .ant-radio-inner {
            width: 30px;
            height: 30px;
        }

        .guide {
            display: flex;
            justify-content: space-between;
            margin-top: 12px;

            p {
                font-size: 16px;
                font-weight: 700;
                color: #808080;
            }
        }
    }

    .agree_box {
        max-width: 340px;
        background-color: #f4f4f4;
        box-sizing: border-box;
        padding: 21px 18px 25px 14px;
        margin: 59px auto 0;

        > .container {
            & + .container {
                margin-top: 22px;
            }
            .ant-radio-group {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .ant-btn {
                padding:0;
                background: none;
                border:none;
                color: #bbbbbb;
                border-bottom: 1px solid #bbbbbb;
                font-size: 16px;
                height: 20px;
            }

            .ant-form-item-control {
                margin-top:0;
            }
        }

        > .contents {
            margin-left:20px;
            width: 270px;
            .cont {
                position: relative;

                &::after {
                    position: absolute;
                    content:"";
                    width: 6px;
                    height: 6px;
                    top:3px;
                    left:-15px;
                    border-radius: 50%;
                    background-color: #f0526d;
                }
                & + .cont {
                    margin-top: 20px;
                }
                p {
                    color: #808080;
                    font-size: 14px;
                    white-space: nowrap;
                    line-height: 16px;
                    font-weight: 600;
                }
            }
        }
    }

    .fordate {
        margin: 29px auto 0;
        width: 300px;
        .cont {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                margin-right: 20px;
            }

            div {
                p {
                    color: #808080;
                    font-size: 14px;
                    line-height: 16px;
                }
            }
        }
    }

    .bt_box {
        display: flex;
        height: 63px;
        margin-top: 55px;

        .prev {
            position: relative;
            width: 37%;
            height: 100%;
            background-color: #dddddd;
            font-size: 12px;
            color: #000;

            img {
                position: absolute;
                top:50%;
                left:22px;
                transform:translateY(-50%);
            }
        }
        .next {
            width: 63%;
            height: 100%;
            background-color: #ff6e75;
            font-size: 12px;
            span {
                color: #fff;
            }

            img {
                position: absolute;
                top:50%;
                right:34px;
                transform:translateY(-50%);
            }
        }
    }

    @media (max-width: 768px) {
        padding: 0 20px;
        margin-top:0;

        .ant-form {
            label {
                display: block;
            }

            .ant-radio-inner {
                width: 24px;
                height: 24px;
            }

            .ant-radio-wrapper {
                margin-right: auto;

                span {
                    white-space: initial;
                }

                &:last-child {
                    span {
                        white-space: nowrap;
                    }
                }
            }

            &.vertical {
                .ant-radio-wrapper {
                    &:last-child {
                        margin-right:0;
                    }
                }
            }
        }
        
        .bt_box {
            width: 100vw;
            margin-left: -20px;
        }
    }
`;

export default DiagnosisTemplate;
